/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';
import type { ContactImportStage } from './ContactImportStage';
import {
    ContactImportStageFromJSON,
    ContactImportStageFromJSONTyped,
    ContactImportStageToJSON,
} from './ContactImportStage';
import type { ContactSource } from './ContactSource';
import {
    ContactSourceFromJSON,
    ContactSourceFromJSONTyped,
    ContactSourceToJSON,
} from './ContactSource';
import type { ContactStatus } from './ContactStatus';
import {
    ContactStatusFromJSON,
    ContactStatusFromJSONTyped,
    ContactStatusToJSON,
} from './ContactStatus';
import type { FileS3Location } from './FileS3Location';
import {
    FileS3LocationFromJSON,
    FileS3LocationFromJSONTyped,
    FileS3LocationToJSON,
} from './FileS3Location';
import type { Summaries } from './Summaries';
import {
    SummariesFromJSON,
    SummariesFromJSONTyped,
    SummariesToJSON,
} from './Summaries';
import type { TrusstGPTMetadata } from './TrusstGPTMetadata';
import {
    TrusstGPTMetadataFromJSON,
    TrusstGPTMetadataFromJSONTyped,
    TrusstGPTMetadataToJSON,
} from './TrusstGPTMetadata';

/**
 * Represents a Contact
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * Amazon connect contact channel
     * @type {string}
     * @memberof Contact
     */
    channel: string;
    /**
     * 
     * @type {ContactStatus}
     * @memberof Contact
     */
    status: ContactStatus;
    /**
     * Time at which the contact started
     * @type {number}
     * @memberof Contact
     */
    startedAt: number;
    /**
     * Time at which the contact finished (if in the completed status)
     * @type {number}
     * @memberof Contact
     */
    completedAt?: number;
    /**
     * 
     * @type {Summaries}
     * @memberof Contact
     */
    summary?: Summaries;
    /**
     * 
     * @type {ContactSource}
     * @memberof Contact
     */
    source?: ContactSource;
    /**
     * The contact import ID which imported this (if any)
     * @type {string}
     * @memberof Contact
     */
    contactImportId?: string;
    /**
     * The connect instance from which this contact was sourced
     * @type {string}
     * @memberof Contact
     */
    connectInstanceId?: string;
    /**
     * Reason why contact was not imported
     * @type {string}
     * @memberof Contact
     */
    reason?: string;
    /**
     * 
     * @type {FileS3Location}
     * @memberof Contact
     */
    s3Location?: FileS3Location;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    audioS3Key?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    jsonS3Key?: string;
    /**
     * 
     * @type {ContactImportStage}
     * @memberof Contact
     */
    stage?: ContactImportStage;
    /**
     * Identifier for a prompt revision
     * @type {string}
     * @memberof Contact
     */
    promptRevisionId?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    language?: string;
    /**
     * 
     * @type {number}
     * @memberof Contact
     */
    maxSpeakers?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Contact
     */
    translateToEnglish?: boolean;
    /**
     * Whether the contact is a reimported contact
     * @type {boolean}
     * @memberof Contact
     */
    isReimported?: boolean;
    /**
     * 
     * @type {ContactStatus}
     * @memberof Contact
     */
    lastRunStatus?: ContactStatus;
    /**
     * 
     * @type {TrusstGPTMetadata}
     * @memberof Contact
     */
    metadata: TrusstGPTMetadata;
    /**
     * The time at which the resource was created
     * @type {number}
     * @memberof Contact
     */
    createdAt: number;
    /**
     * The time of the most recent update
     * @type {number}
     * @memberof Contact
     */
    updatedAt: number;
    /**
     * Identifier for a Contact
     * @type {string}
     * @memberof Contact
     */
    contactId: string;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof Contact
     */
    createdBy?: CallingIdentity;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof Contact
     */
    updatedBy?: CallingIdentity;
}


/**
 * Check if a given object implements the Contact interface.
 */
export function instanceOfContact(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "channel" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "startedAt" in value;
    isInstance = isInstance && "metadata" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "contactId" in value;

    return isInstance;
}

export function ContactFromJSON(json: any): Contact {
    return ContactFromJSONTyped(json, false);
}

export function ContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): Contact {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'channel': json['channel'],
        'status': ContactStatusFromJSON(json['status']),
        'startedAt': json['startedAt'],
        'completedAt': !exists(json, 'completedAt') ? undefined : json['completedAt'],
        'summary': !exists(json, 'summary') ? undefined : SummariesFromJSON(json['summary']),
        'source': !exists(json, 'source') ? undefined : ContactSourceFromJSON(json['source']),
        'contactImportId': !exists(json, 'contactImportId') ? undefined : json['contactImportId'],
        'connectInstanceId': !exists(json, 'connectInstanceId') ? undefined : json['connectInstanceId'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        's3Location': !exists(json, 's3Location') ? undefined : FileS3LocationFromJSON(json['s3Location']),
        'audioS3Key': !exists(json, 'audioS3Key') ? undefined : json['audioS3Key'],
        'jsonS3Key': !exists(json, 'jsonS3Key') ? undefined : json['jsonS3Key'],
        'stage': !exists(json, 'stage') ? undefined : ContactImportStageFromJSON(json['stage']),
        'promptRevisionId': !exists(json, 'promptRevisionId') ? undefined : json['promptRevisionId'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'maxSpeakers': !exists(json, 'maxSpeakers') ? undefined : json['maxSpeakers'],
        'translateToEnglish': !exists(json, 'translateToEnglish') ? undefined : json['translateToEnglish'],
        'isReimported': !exists(json, 'isReimported') ? undefined : json['isReimported'],
        'lastRunStatus': !exists(json, 'lastRunStatus') ? undefined : ContactStatusFromJSON(json['lastRunStatus']),
        'metadata': TrusstGPTMetadataFromJSON(json['metadata']),
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'contactId': json['contactId'],
        'createdBy': !exists(json, 'createdBy') ? undefined : CallingIdentityFromJSON(json['createdBy']),
        'updatedBy': !exists(json, 'updatedBy') ? undefined : CallingIdentityFromJSON(json['updatedBy']),
    };
}

export function ContactToJSON(value?: Contact | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'channel': value.channel,
        'status': ContactStatusToJSON(value.status),
        'startedAt': value.startedAt,
        'completedAt': value.completedAt,
        'summary': SummariesToJSON(value.summary),
        'source': ContactSourceToJSON(value.source),
        'contactImportId': value.contactImportId,
        'connectInstanceId': value.connectInstanceId,
        'reason': value.reason,
        's3Location': FileS3LocationToJSON(value.s3Location),
        'audioS3Key': value.audioS3Key,
        'jsonS3Key': value.jsonS3Key,
        'stage': ContactImportStageToJSON(value.stage),
        'promptRevisionId': value.promptRevisionId,
        'language': value.language,
        'maxSpeakers': value.maxSpeakers,
        'translateToEnglish': value.translateToEnglish,
        'isReimported': value.isReimported,
        'lastRunStatus': ContactStatusToJSON(value.lastRunStatus),
        'metadata': TrusstGPTMetadataToJSON(value.metadata),
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'contactId': value.contactId,
        'createdBy': CallingIdentityToJSON(value.createdBy),
        'updatedBy': CallingIdentityToJSON(value.updatedBy),
    };
}

